import {
    GET_CMS_MAIN_MENU
} from "../actions/types";

const initialState = [];
const cmsReducer = function (state=initialState, action) {
    const {type, payload } = action;    
    switch (type) {        
        case GET_CMS_MAIN_MENU:
            return {
                ...state,
                contentMenu: payload.data
            }
        default:
            return state;
    }
};

export default cmsReducer;